// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1708":"32878e93","2391":"32878e93","3605":"f204139c","5089":"32878e93","7150":"32006cf2","8407":"7a3fd530"}[chunkId] + ".chunk.css";
};